export default __webpack_public_path__ + "static/icon-5-3-792234bdfb32ba5ed00798e5f42ac4ab.png";